import React from 'react';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {viewStyles} from '../shared/styles-view';
import {Card, CardText} from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import ModeIcon from 'material-ui/svg-icons/device/settings-system-daydream';
import ConfigurationModeToggleForm from "../components/ConfigurationModeToggleForm";

export const fuseModeIcon = ModeIcon;

const styles = {
    cardTitle: {display: 'inline-block', fontSize: 24, color: 'rgba(0, 0, 0, 0.87)', lineHeight: 36},
};

// Set title for Set Mode
const ChooseTitle = () => {
    return (
        <span><Avatar icon={<ModeIcon/>} style={viewStyles.avatar} className="avatar-title"/>Admin Mode</span>
    )
};

export const fuseSetMode = (props) => (
    <div>
        <Card>
            <ViewTitle title={<ChooseTitle/>} style={styles.cardTitle}/>
            <CardText>
                <p>Set the Admin to <strong>Live</strong> Mode or <strong>Test</strong> Mode.</p>
                <p>Test mode is primarily for Inventory, Sales and Loyalty Programs. When Mode is set
                    to <em>Test</em>, the Admin will send and receive only test data. Most areas (such as
                    Locations and Products) are not concerned with Mode.</p>
                <ConfigurationModeToggleForm {...props}/>
            </CardText>
        </Card>
    </div>
);



// WEBPACK FOOTER //
// ./src/Fuse/Setting/setMode.js